import { render, staticRenderFns } from "./create-recruit.vue?vue&type=template&id=04c9da96&"
import script from "./create-recruit.vue?vue&type=script&lang=ts&"
export * from "./create-recruit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-recruit.vue"
export default component.exports